import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { centerPlacement } from '../../../modules/utils/constants/constants';

interface BioInfoProps {
  descriptionAlignment?: string;
}

export const StyledBioCard = styled.div`
  flex-direction: column;
  align-items: center;

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    column-gap: ${toRem(32)};
    flex-direction: row;
    align-items: unset;
  }

  .bio-card {
    &__image {
      border-radius: ${toRem(14)};
    }
  }

  &:nth-child(even) {
    .bio-card__image {
      order: unset;

      @media ${baseVariables.mediaQuery.md},
        @media ${baseVariables.mediaQuery.lg},
        @media ${baseVariables.mediaQuery.xl} {
        order: 1;
      }
    }
  }
`;

export const StyledBioInfo = styled.div<BioInfoProps>`
  padding-top: ${toRem(32)};
  padding-bottom: ${toRem(32)};
  margin: ${props =>
    props.descriptionAlignment === centerPlacement ? `${toRem(16)} ${toRem(16)} ${toRem(24)} ${toRem(16)}` : ''};

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
  }

  .truncated-description {
    display: -webkit-box;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .full-description {
    display: block;
  }

  .show-more-button,
  .show-more-button:hover,
  .show-more-button:focus {
    background: none;
  }

  .show-more-icon {
    &:: before {
      font-size: ${toRem(16)};
      line-height: ${toRem(16)};
    }
  }
`;
